<template>
  <div ref="pdfContainer" id="ContractPDF" class="form-control p-0">
    <div v-if="loading" class="text-center my-3">
      <span class="inline-loader"></span>
    </div>
    <error-banner v-else-if="error" :message="error"/>
    <vue-pdf-embed v-else-if="pdfSource" :source="pdfSource" :width="pdfWidth"/>
  </div>
</template>

<script>
import { ErrorHelper } from '@/helpers/ErrorHelper'
import { WebApi } from '@/services/WebApi'
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'
import ErrorBanner from '../../ErrorValidation/ErrorBanner.vue'

export default {
  name: 'PdfContainer',
  props: {
    siteId: { type: String, required: true }
  },
  data () {
    return {
      error: '',
      loading: false,
      pdfSource: '',
      pdfWidth: 0
    }
  },
  methods: {
    tryFetchPdf () {
      const self = this
      if (self.loading) return
      self.error = ''
      self.loading = true
      WebApi.get('Portal/' + self.siteId + '/ClientRegistration/ContractTemplate/Pdf')
        .then(response => {
          self.pdfSource = 'data:application/pdf;base64,' + response.data
          self.setPdfWidth()
        })
        .catch(error => { self.error = ErrorHelper.getError(error) })
        .finally(() => { self.loading = false })
    },
    setPdfWidth () {
      this.$nextTick(() => {
        const container = this.$refs.pdfContainer
        if (container) {
          this.pdfWidth = container.getBoundingClientRect().width
        }
      })
    }
  },
  mounted () {
    this.$nextTick(() => { this.setPdfWidth() })
    window.addEventListener('resize', this.setPdfWidth)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.setPdfWidth)
  },
  created () {
    this.tryFetchPdf()
  },
  components: {
    VuePdfEmbed,
    'error-banner': ErrorBanner
  }
}
</script>

<style scoped>
#ContractPDF {
  overflow: auto;
  height: 80vh !important;
  width: 100%;
  overflow-x: hidden;
}

@media screen and (max-width: 768px) {
  #ContractPDF {
    height: 80vh !important;
  }
}
</style>
